import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'

export const PlusBoldIcon: FunctionComponent<IconProps> = ({
  fill,
  customColour,
  width = 16,
  height = 16,
  ...rest
}) => {
  const fillColour = customColour ? customColour : '#0050B3'

  return (
    <Icon
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <path
        d="M7 7V1H9V7H15V9H9V15H7V9H1V7H7Z"
        fill={fillColour}
        stroke="black"
        strokeWidth="2"
        fillRule="evenodd"
      />
    </Icon>
  )
}
